import React, {FC} from 'react'
import clsx from "clsx";
import {KTIcon} from "../../../../_metronic/helpers";

type PageHeaderProps = {
  pageDetails: {
    title: string,
    desc: string,
    buttons?: {
      onClick?: () => void,
      text?: string,
      disabled?: boolean,
      className?: string
      icon?: string,
    }[]
  }
}

export const PageHeader: FC<PageHeaderProps> = ({pageDetails}) => {
  return (
      <div className={"d-flex align-items-center justify-content-between mb-5"}>
        <div>
          <h1 className={"page-heading d-flex text-gray-900 fw-bold fs-3 my-0 flex-column justify-content-center"}>{pageDetails?.title}</h1>
          <p className={"text-muted m-0"}>{pageDetails?.desc}</p>
        </div>
        <div className={"d-flex gap-2"}>
          {pageDetails?.buttons && pageDetails?.buttons.map((item, index) => (
              <button disabled={item?.disabled || false} key={index} className={
                clsx(
                    "btn",
                    item?.className, "btn-primary",
                    "btn-hover-primary d-flex align-items-center"
                )
              }
                      onClick={item.onClick}>
                {item?.icon && <KTIcon className={"fs-1"} iconType={"duotone"} iconName={item?.icon}/>}
                {item.text}</button>
          ))}
        </div>
      </div>
  )
}